import React, { Component } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DayPickerRangeController } from 'react-dates';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';

class DayPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
    };
  }

  onDatesChange = ({ startDate, endDate }) => {
    const { handleChangeDate, getDaysInWeek } = this.props;
    handleChangeDate(startDate, endDate);
    getDaysInWeek(startDate);
  };

  render() {
    const { startDate, endDate } = this.props;
    return (
      <DayPickerRangeController
        startDate={startDate}
        endDate={endDate}
        initialVisibleMonth={() => startDate}
        focusedInput={this.state.focusedInput}
        enableOutsideDays
        hideKeyboardShortcutsPanel
        noBorder
        daySize={35}
        navPrev={
          <span id="prev-month">
            <FontAwesomeIcon icon={['fal', 'chevron-left']} />
          </span>
        }
        navNext={
          <span id="next-month">
            <FontAwesomeIcon icon={['fal', 'chevron-right']} />
          </span>
        }
        firstDayOfWeek={1}
        onFocusChange={focusedInput => this.setState({ focusedInput })}
        onDatesChange={this.onDatesChange}
        startDateOffset={day => day.startOf('isoWeek')}
        endDateOffset={day => day.endOf('isoWeek')}
      />
    );
  }
}

export default DayPicker;



// WEBPACK FOOTER //
// ./src/components/Book/FilterSidebar/Daypicker.js